<style >
@import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100..900;1,100..900&display=swap');


.app{
 
}

.roboto-100 {
  font-family: "Roboto", sans-serif;
  font-optical-sizing: auto;
  font-weight: 100;
  font-style: normal;
  font-variation-settings:
    "wdth" 100;
}
/*
p,
a {
  letter-spacing: 2px;
  font-weight: 100 !Important;
  line-height: 2 !important;
}
*/
.auth-container p,
.auth-container a {
  letter-spacing: 2px;
  font-weight: 100;
}


.ai_summary {
  font-size: 18px;
  line-height: 1.8;
  font-weight: 300 !important;
}

.auth-container {
  max-width: 600px;
  margin-left:  auto;
  margin-right: auto;
  max-width: auto;
  padding: 2rem;
  width: 96%;
  
 
 
}

.auth-container h3 {
  margin-bottom: 1rem;
  text-align: center;
}

.auth-container p {
  margin-top: 1rem;
  text-align: center;
}

.btn-login {
 
  border-radius: 3px !important;
  box-shadow: none !important;
  
  height: 47px !important;
  width: 100%;
 
  
}

 

.google-btn {
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  height: 47px !important;
  padding: 12px 14px;
  border-radius: 3px;
  margin-top:4px;

  border: 1px solid rgba(0,0,0,0.12);
  background: #ffffff!important;
  color: #111827!important;

  font: 600 14px/1 system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif;
  letter-spacing: 0.2px;

  cursor: pointer;
  user-select: none;

  transition: transform 0.04s ease, box-shadow 0.18s ease, border-color 0.18s ease;
 
}

/*
.google-btn:hover {
 
}

.google-btn:active {
  transform: translateY(1px);
  box-shadow: 0 2px 8px rgba(0,0,0,0.10);
}

.google-btn:focus-visible {
  outline: none;
  box-shadow: 0 0 0 4px rgba(59,130,246,0.25), 0 6px 18px rgba(0,0,0,0.10);
}
*/


.google-btn__icon {
  display: inline-flex;
  width: 22px;
  height: 22px;
  align-items: center;
  justify-content: center;
  
  background: #fff;
  border-radius: 8px;
}

.google-btn__text {
  white-space: nowrap;
}

</style>



<style scoped>
.btn {
 height: 55px !important;
}

</style>



 







<template  color="primary">
  <v-app class="app "  >

 
    
    <!-- Wait for Firebase to finish checking user -->
    <div v-if="loadingUser"   class="d-flex align-center justify-center"
    :style="{
      height: '100vh',
      background: theme === 'light' ? 'white' : 'var(--bg-dark)'
    }"
    >
      <!--<div style="height:100vh; width:100vw; background-color:var(--v-theme-background)"></div>-->
      <v-progress-circular
        indeterminate
        color="#1F7A63"
        bg-color="transparent"
        size="70"
      />
    </div>
  
 

    <!-- --------------------------------------------------
    | Show sign-in/register form if not signed in 
    --------------------------------------------------- -->
    <div v-else-if="!user" class="app-shell pt-9 " style=" ">

    <v-main style=" " class="content">
 
      <div style="max-width: 600px; width: 94%; margin: auto;" class="mb-13">
        <v-sheet  class="pa-0"  style="  width:100%!important" color="transparent">
        

        <v-form @submit.prevent="handleAuth" class="pa-3" style="  width:100%!important " >
          <v-row style=" " >

            <v-col cols="12" md="12" class="ma-0 pt-0 pb-0" style="text-align: center;"> 
                <p 
                  style="
                    border:5px solid;
                    padding:5px 9px;
                    margin:auto;
                    font-weight:900!important;
                    font-size:31px;
                    line-height:1!important;
                    display:inline-block;
                  
                  "
                  class="mb-6"
                >
                  LWYR
                </p>
            </v-col>

            <v-col cols="12" md="12" class="ma-0 pt-0 pb-0" style=" "> 
              <h2 class="mb-3">{{ isRegister ? "Register" : "Login" }}</h2>
            </v-col>


            <v-col v-if="isRegister" cols="12" md="6" class="ma-0 pt-0 pb-0" style=" "> 
              <v-text-field   variant="outlined" class="login-input " v-model="firstName" label="First Name" required  style="    "   />
            </v-col>

            <v-col v-if="isRegister" cols="12" md="6" class="ma-0 pt-0 pb-0"> 
              <v-text-field   variant="outlined" class="login-input" v-model="lastName" label="Last Name (optional)"  style="  "  />
            </v-col>
        
      
            <v-col cols="12" md="12" class="ma-0 pt-0 pb-0"> 
              <v-text-field variant="outlined" class="login-input" v-model="email" label="Email" type="email" required  style="   "  />
            </v-col>
      
            <v-col cols="12" md="12" class="ma-0 pt-0 pb-0"> 
              <v-text-field variant="outlined" class="login-input"  v-model="password" label="Password" type="password" required />
            </v-col>
      
            <v-col cols="12" md="12" class="ma-0 pt-0 pb-0"> 
              <v-text-field v-if="isRegister" variant="outlined" class="login-input" v-model="confirmPassword" label="Confirm Password" type="password" required  style="  width:100%!important "  />
            </v-col>

  
            <v-col cols="12" md="6" class="ma-0 pt-0 pb-0"> 
              <v-btn class="btn mt-1 btn-login" type="submit" variant="tonal" style="background-color: var(--accent-primary)!important; color: var(--v-primary)"   block>
                {{ isRegister ? "Register" : "Login" }}
              </v-btn>
            </v-col>
    
            <v-col cols="12" md="6" class="ma-0 pt-0 pb-0"> 
              <v-btn class="btn google-btn" @click="signInWithGoogle"  variant="outlined"  block style="">
                <span class="google-btn__icon" aria-hidden="true">
                
                  <svg width="18" height="18" viewBox="0 0 48 48">
                    <path fill="#FFC107" d="M43.611 20.083H42V20H24v8h11.303C33.671 32.66 29.225 36 24 36c-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.968 3.032l5.657-5.657C34.95 6.053 29.727 4 24 4 12.955 4 4 12.955 4 24s8.955 20 20 20 20-8.955 20-20c0-1.341-.138-2.65-.389-3.917z"/>
                    <path fill="#FF3D00" d="M6.306 14.691l6.571 4.819C14.655 15.108 18.961 12 24 12c3.059 0 5.842 1.154 7.968 3.032l5.657-5.657C34.95 6.053 29.727 4 24 4c-7.682 0-14.35 4.337-17.694 10.691z"/>
                    <path fill="#4CAF50" d="M24 44c5.623 0 10.743-2.053 14.625-5.406l-6.744-5.703C29.873 34.347 27.093 36 24 36c-5.203 0-9.635-3.314-11.28-7.946l-6.52 5.025C9.505 39.556 16.227 44 24 44z"/>
                    <path fill="#1976D2" d="M43.611 20.083H42V20H24v8h11.303c-.792 2.325-2.273 4.279-4.242 5.592l.003-.002 6.744 5.703C36.75 40.27 44 35 44 24c0-1.341-.138-2.65-.389-3.917z"/>
                  </svg>

                </span>
                <span class="google-btn__text">Sign in with Google</span>
              </v-btn>
            </v-col>



            <v-col v-if="isRegister" cols="12" md="12" class="ma-0 pt-0 pb-0 mt-9"> 
              <v-checkbox v-model="termsAndPolicy">
                <template #label>
                  <div>
                    I agree to the 
                    <a href="#" @click.prevent="showTerms = true" style="color: var(--v-primary); font-weight: 400!important;">
                      Terms & Conditions
                    </a>
                    and the 
                    <a href="#" @click.prevent="showPrivacy = true"  style="color: var(--v-primary); font-weight: 400!important;">
                      Privacy Policy
                    </a>
                  </div>
                </template>
              </v-checkbox>
              <v-checkbox v-model="emailConsent">
                <template #label>
                  <div>
                    I agree to receive marketing emails from LWYR. I understand I can unsubscribe at any time.
                  </div>
                </template>
              </v-checkbox>
            </v-col>


          </v-row>
          
        
  
        </v-form>
    
   
        </v-sheet>




        <div class="mt-13" style="text-align: center;">

          <p style="margin: auto;">
            {{ isRegister ? "Already have an account?" : "Don't have an account?" }}
            <a href="#" @click.prevent="isRegister = !isRegister" style=" font-weight:bold!important; color: var(--v-primary)"   >
              {{ isRegister ? "Login" : "Register" }}
            </a>
          </p>

          <Terms v-model="showTerms" />
          <Privacy v-model="showPrivacy" />
        </div>


      </div>

    </v-main>  
    </div>
    <!-- --------------------------------------------------
    | 
    --------------------------------------------------- -->



    <!-- --------------------------------------------------
    | Show app if signed in  v-else
    --------------------------------------------------- -->
    <div v-else-if="user && !user.emailVerified" class="auth-container" style="text-align: center; ">
      <p>Please verify your email to continue.</p>

      <v-btn
        variant="outlined"
        size="small"
        class="mt-3  "
        :loading="sending"
        :disabled="sending"
        @click="resendVerification"
        style="margin:auto; height:50px "
      >
        {{ sending ? 'Sending…' : 'Resend verification email' }}
      </v-btn>

      <p v-if="sent" class="mt-2 text-success">
        Verification email sent.
      </p>
    </div>


 

    <div v-else style=" "  class="app-shell">
      <!--
      <v-layout style="height: 50px; ">
        <v-system-bar color="#313131" style="position: fixed"  elevation="3">
          <v-icon class="ms-2" >
            
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="m482-200 114-113-114-113-42 42 43 43q-28 1-54.5-9T381-381q-20-20-30.5-46T340-479q0-17 4.5-34t12.5-33l-44-44q-17 25-25 53t-8 57q0 38 15 75t44 66q29 29 65 43.5t74 15.5l-38 38 42 42Zm165-170q17-25 25-53t8-57q0-38-14.5-75.5T622-622q-29-29-65.5-43T482-679l38-39-42-42-114 113 114 113 42-42-44-44q27 0 55 10.5t48 30.5q20 20 30.5 46t10.5 52q0 17-4.5 34T603-414l44 44ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg>
          </v-icon>


          

          <v-icon class="ms-2" >
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="M480-480Zm-400 0q0-88 34-163t93-130q59-55 136-83.5T508-879q17 2 27 14.5t7 29.5q-3 17-16.5 27t-30.5 9q-69-3-129.5 19.5T259-713q-46 44-72.5 103.5T160-480q0 134 93 227t227 93q69 0 128.5-26.5T712-259q46-48 68-109t19-127q-1-17 9-30.5t27-16.5q17-3 29.5 7t14.5 27q6 87-22.5 164T774-208q-57 62-133 95T480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480Zm640-120q-50 0-85-35t-35-85q0-50 35-85t85-35q50 0 85 35t35 85q0 50-35 85t-85 35Z"/></svg>
          </v-icon>

          <v-icon class="ms-2"  >
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="M480-28 346-160H160v-186L28-480l132-134v-186h186l134-132 134 132h186v186l132 134-132 134v186H614L480-28Zm0-252q83 0 141.5-58.5T680-480q0-83-58.5-141.5T480-680v400Zm0 140 100-100h140v-140l100-100-100-100v-140H580L480-820 380-720H240v140L140-480l100 100v140h140l100 100Zm0-340Z"/></svg>
          </v-icon>


          <span class="ms-2">08:30</span>
        </v-system-bar>
      </v-layout>-->

      <SideNav v-if="mdAndUp" :onSignOut="signOut" :userName="user && (user.displayName || user.email)" />
      
      <v-main style="   " class="content">

        
        <router-view />
        <Footer v-if="$route.name !== 'settings' && $route.path !== '/admin' "></Footer>
      </v-main>
      <BottomNav :onSignOut="signOut"  v-if="!mdAndUp" ></BottomNav>
      <!--<BottomNav/>-->


      <!-- bottom nav stays the same 
      <v-bottom-navigation v-model="selectedNav" style="background-color: #414141; height:60px " grow density="compact">

        <v-btn  class="nav-bottom-btn d-sm-none" value="recent" style="color:white; ">
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="M120-240v-80h720v80H120Zm0-200v-80h720v80H120Zm0-200v-80h720v80H120Z"/></svg>
          <span>Menu</span>
        </v-btn>
        <v-btn to="/" class="nav-bottom-btn" value="recent" style="color:white; ">
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="M240-200h120v-240h240v240h120v-360L480-740 240-560v360Zm-80 80v-480l320-240 320 240v480H520v-240h-80v240H160Zm320-350Z"/></svg>
          <span class="d-none d-sm-inline">Home</span>
        </v-btn>
        <v-btn class="nav-bottom-btn"  value="recent" style="color:white">
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#ededed"><path d="m480-120-58-52q-101-91-167-157T150-447.5Q111-500 95.5-544T80-634q0-94 63-157t157-63q52 0 99 22t81 62q34-40 81-62t99-22q94 0 157 63t63 157q0 46-15.5 90T810-447.5Q771-395 705-329T538-172l-58 52Zm0-108q96-86 158-147.5t98-107q36-45.5 50-81t14-70.5q0-60-40-100t-100-40q-47 0-87 26.5T518-680h-76q-15-41-55-67.5T300-774q-60 0-100 40t-40 100q0 35 14 70.5t50 81q36 45.5 98 107T480-228Zm0-273Z"/></svg>
          <span class="d-none d-sm-inline">Favorites</span>
        </v-btn>

     
        <v-btn class="nav-bottom-btn"  value="recent" style="color:white">
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="m422-232 207-248H469l29-227-185 267h139l-30 208ZM320-80l40-280H160l360-520h80l-40 320h240L400-80h-80Zm151-390Z"/></svg>
          <span class="d-none d-sm-inline">New</span>
        </v-btn> 
        <v-btn  to="/history" class="nav-bottom-btn"  value="recent" style="color:white">
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="M600-160q-134 0-227-93t-93-227q0-133 93-226.5T600-800q133 0 226.5 93.5T920-480q0 134-93.5 227T600-160Zm0-80q100 0 170-70t70-170q0-100-70-170t-170-70q-100 0-170 70t-70 170q0 100 70 170t170 70Zm91-91 57-57-108-108v-144h-80v177l131 132ZM80-600v-80h160v80H80ZM40-440v-80h200v80H40Zm40 160v-80h160v80H80Zm520-200Z"/></svg>
          <span class="d-none d-sm-inline">Viewed</span>
        </v-btn>
      </v-bottom-navigation>-->

      
    </div>
    <!-- --------------------------------------------------
    | 
    --------------------------------------------------- -->
    
  </v-app>
  
</template>







<script setup>
/* --------------------------------------------------
| Imports
-------------------------------------------------- */
import { ref, onMounted } from 'vue'
import { useDisplay } from 'vuetify'
import { useRouter } from 'vue-router'

import {
  getAuth,
  onAuthStateChanged,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signInWithPopup,
  GoogleAuthProvider,
  sendEmailVerification,
  signOut as firebaseSignOut
} from 'firebase/auth'


import { doc, setDoc } from "firebase/firestore"
import { db } from "@/firebase"

import { articleState } from '@/store/articlesStore'
import { auth } from '@/firebase'
import { serverTimestamp } from "firebase/firestore"


/* Components */
import SideNav from './components/SideNav.vue'
import BottomNav from './components/BottomNav.vue'
import Header from './components/general/Header.vue'
import Footer from './components/general/Footer.vue'
import Terms from './components/general/Terms.vue'
import Privacy from './components/general/Privacy.vue'


// check admin status
import { checkAdmin } from "@/store/authStore"
onMounted(() => {
  checkAdmin(auth)
})


const theme = localStorage.getItem('theme');






const showTerms = ref(false)
const showPrivacy = ref(false)

const termsAndPolicy = ref(false)
const emailConsent = ref(false)







 
const display1 = useDisplay()
console.log(display1.name.value) 

/* --------------------------------------------------
| Vuetify / Router
-------------------------------------------------- */
const { mdAndUp } = useDisplay()
const router = useRouter()

/* --------------------------------------------------
| Auth State
-------------------------------------------------- */
const user = ref(null)
const loadingUser = ref(true)

const email = ref('')
const password = ref('')

const firstName = ref('')
const lastName = ref('')
const confirmPassword = ref('')



const isRegister = ref(false)

/* Email verification resend */
const sending = ref(false)
const sent = ref(false)

/* --------------------------------------------------
| Firebase auth listener
-------------------------------------------------- */
onMounted(() => {
  onAuthStateChanged(auth, (currentUser) => {
    user.value = currentUser
    articleState.user = currentUser
    loadingUser.value = false
  })
})

/* --------------------------------------------------
| Auth actions
-------------------------------------------------- */
const handleAuth = async () => {
  if (!email.value || !password.value) {
    alert('Please enter email and password')
    return
  }

  try {

    // Register new user with email/password if isRegister is true
    if (isRegister.value) {
       
      if (!firstName.value) {
        alert('Please enter first name')
        return
      }

      if(confirmPassword.value !== password.value){
        alert("Passwords do not match")
        return
      }   

      if(!termsAndPolicy.value){
        alert("You must agree to the Terms & Conditions and Privacy Policy to register")
        return
      }

 

      const result = await createUserWithEmailAndPassword(
        auth,
        email.value,
        password.value
      )
      await sendEmailVerification(result.user)

      /*
      var emailOptInDate = ''
      if(emailConsent.value === true){
        emailOptInDate = serverTimestamp()
      }*/
         
      // Create Firestore user document
      await setDoc(doc(db, "users", result.user.uid), {
        email: email.value,
        firstName: firstName.value,
        lastName: lastName.value,
        role: "user",
        createdAt: serverTimestamp(),
        user_id: result.user.uid,

        /*
        termsAndPolicy: termsAndPolicy.value,
        termsAndPolicyDate:  serverTimestamp(),
        emailOptIn: emailConsent.value,
        emailOptInDate: emailOptInDate*/

        agreeToTerms: true,
        agreeToTermsDate: serverTimestamp(),
        agreeToTermsVersion: "2026-02-18",

        agreeToPrivacy: true,
        agreeToPrivacyDate: serverTimestamp(),
        agreeToPrivacyVersion: "2026-02-18",

        emailOptIn: emailConsent.value,
        emailOptInDate: emailConsent.value ? serverTimestamp() : null

      })

      user.value = result.user
    } 

    // Sign in with email/password if not registering
    else {
      const result = await signInWithEmailAndPassword(
        auth,
        email.value,
        password.value
      )
      user.value = result.user
    }

    email.value = ''
    password.value = ''
  } 
  catch (err) {
    alert(err.message)
  }
}

const signInWithGoogle = async () => {
  try {
    const provider = new GoogleAuthProvider()
    const result = await signInWithPopup(auth, provider)
    user.value = result.user
  } catch (err) {
    alert(err.message)
  }
}

const signOut = async () => {
  try {
    await firebaseSignOut(auth)
    user.value = null
  } catch (err) {
    alert(err.message)
  }
}

/* --------------------------------------------------
| Resend verification email
-------------------------------------------------- */
const resendVerification = async () => {
  if (!auth.currentUser) return

  sending.value = true
  sent.value = false

  try {
    await sendEmailVerification(auth.currentUser)
    sent.value = true
  } catch (err) {
    console.error('Verification email error:', err)
  } finally {
    sending.value = false
  }
}
</script>

   <!--
        <v-btn class="btn-login" @click="signInWithGoogle" block style="">
          Sign in with Google
        </v-btn>-->
